import VueScript2 from 'vue-script2'
import toastr from 'toastr'
import * as reset from '@/store/reset'

let pushNotify = null
let pubnubOptions = {}

export const init = (
  pubnub_data = {}
) => {
  return new Promise((resolve, reject) => {
    /* const user = store.getters[AUTH_CURRENT_USER] */
    const pubNubUrl = 'https://cdn.pubnub.com/sdk/javascript/pubnub.4.22.0.js'

    // We use the VueScript2 Vue library to dynamically load the pubnub API scripts.
    VueScript2.load(pubNubUrl).then(() => {
      pubnubOptions = Object.assign({}, pubnub_data)
      pushNotify = new PubNub({ // eslint-disable-line
        subscribeKey: pubnubOptions.subscribe_key,
        publishKey: pubnubOptions.publish_key,
        ssl: location.protocol === 'https:'
      })

      if (pubnubOptions.sub_channels) {
        pushNotify.addListener({
          message: function (received) {
            let data = received.message

            if (data.hasOwnProperty('type')) {
              if (data.type === 'command') {
                switch (data.action) {
                  case 'logout':
                    reset.resetAll()
                    toastr.warning('You have been logged out by the server.', 'Warning')
                    break
                }
              } else {
                let options = { timeOut: 0 }

                switch (data.type) {
                  case 'success':
                    toastr.success(data.message, 'Success', options)
                    break

                  case 'warning':
                    toastr.warning(data.message, 'Warning', options)
                    break

                  case 'error':
                    toastr.error(data.message, 'Error', options)
                    break

                  default:
                    toastr.info(data.message, 'Notification', options)
                }
              }
            }
          },
          presence: function (presence) {
            console.log('DEBUG: pubnub:presense: ', presence)
          },
          status: function (status) {
            console.log('DEBUG: pubnub:status: ', status)
          }
        })

        pushNotify.subscribe({
          channels: pubnubOptions.sub_channels
        })
      }
      resolve()
    }).catch(error => {
      reject(error)
    })
  })
}

export const unsub = () => {
  /*
  pushNotify.unsubscribe({
    channels: pubnubOptions.sub_channels
  })
  */
}



// WEBPACK FOOTER //
// ./src/common/pubnub.js